import StandardDirection from "./standard-direction";

const KeyboardMoveActionMap = {
    ArrowUp: StandardDirection.FORWARD,
    W: StandardDirection.FORWARD,
    w: StandardDirection.FORWARD,
    ArrowDown: StandardDirection.BACKWARD,
    S: StandardDirection.BACKWARD,
    s: StandardDirection.BACKWARD,
    ArrowLeft: StandardDirection.LEFT,
    A: StandardDirection.LEFT,
    a: StandardDirection.LEFT,
    ArrowRight: StandardDirection.RIGHT,
    D: StandardDirection.RIGHT,
    d: StandardDirection.RIGHT,
    PageUp: StandardDirection.UP,
    E: StandardDirection.UP,
    e: StandardDirection.UP,
    PageDown: StandardDirection.DOWN,
    Q: StandardDirection.DOWN,
    q: StandardDirection.DOWN
};

export default KeyboardMoveActionMap;
